import React from 'react';
import useDeploy from './useDeploy';
import DeployMode from './DeployMode';

// The version to deploy comes from the caller, worked out from the history, and the server refuses one that
// exists. So this doesn't load the history itself: in full (every page of every deployment ever made) it was
// slow to send and froze the browser while Apollo stored it, and nothing here used it.
const DeployModeContainer = (props) => {
  const { deploy } = useDeploy();

  return <DeployMode {...props} onClickDeploy={deploy} />;
};

export default DeployModeContainer;
